<style scoped lang="less">
  .field {
    padding-top: 10px;
  }
</style>
<template>
  <div class="content pr-2">
    <!--start franshise-->
    <div
      v-if="franchises.length == 0"
      class="field text-center"
    >
      <span>There were no missing tournaments located.</span>
    </div>
    <div
      v-for="franchise in franchises"
      class="columns"
    >
      <div class="column is-12">
        <div class="column is-12 card-header has-text-centered button-tools">
          <strong>{{ franchise.name }}</strong>
        </div>
        <div class="is-flex flex-wrap">
          <!--start card-->
          <div
            v-for="venue in franchise.venues"
            class="field"
          >
            <router-link :to="`/venues/${venue.venueid}`">
              <div class="is-flex flex-wrap">
                <div class="box mb-0 m-1 is-flex align-center">
                  <!--<div class="b-checkbox is-circular">-->
                  <!--<input id="card-1" type="radio">-->
                  <!--<label for="card-1"></label>-->
                  <!--</div>-->
                  <div class="ml-4">
                    <strong class="is-size-7-touch">{{ venue.venueName }}</strong>
                    <span class="has-text-danger is-block is-size-7-touch">{{ venue.time }}</span>
                    <span class="has-text-info is-size-7-touch">{{ venue.date }}</span>
                    <span class="is-block is-size-7-touch">{{ venue.timeLate }}</span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <!--end card-->
        </div>
      </div>
    </div>
    <!--end franshise-->
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'MissingTournaments',
    props: ['token', 'user'],
    data() {
      return {
        franchises: []
      }
    },
    computed: {},
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getPendingTournaments()
    },
    methods: {
      getPendingTournaments() {
        let url = `admin/tournaments/missing`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.franchises = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true,message: error.response.data.message})
          })
      }
    }
  }
</script>
